export class PagarQuitarDados {
  PagarId = 0;
  DataPagamento: string;
  NovoHistorico = '';

  constructor(id: number, data: string, historico: string) {
    this.PagarId = id;
    this.DataPagamento = data;
    this.NovoHistorico = historico;
  }
}
